import { useIdleTimer } from 'react-idle-timer';
import { useSessionApi } from '../apis/session-api';
import { useStorage } from './use-storage';

function useSession() {
  const { session, setSession, menuId } = useStorage();
  const { refreshSessionFromRemote } = useSessionApi();

  useIdleTimer({
    timeout: 2000,
    onActive: refresh,
    onAction: refresh,
    debounce: 1000,
  });

  async function refresh() {
    if (session?.id != null && menuId != null) {
      try {
        const result = await refreshSessionFromRemote(session.id);
        setSession(result.data);
      } catch (error) {
        if ([409, 410].includes(error.response?.status)) {
          setSession(null);
        }
      }
    }
  }
}

export { useSession };
